export default {
  //<!------- titles --------!>
  'privacy.policy': 'プライバシーポリシー',
  'privacy.lastupdate': '最終更新日: 2018-12-14',
  'privacy.highlights': 'このプライバシーポリシーのハイライト',
  'privacy.informationcollect': 'どのような情報を収集しますか?',
  'privacy.sharepersonalinformation': '個人情報の共有先',
  'privacy.usepersonalinformation': '個人情報の使用方法',
  'privacy.howmanageinformation':
    'あなたが私たちに提供した情報をどのように管理できますか?',
  'privacy.howprotectinformation': 'お客様の情報をどのように保護しますか?',
  'privacy.howcontactus': 'お問い合わせ方法',
  //<!------ introduction --------!>
  'privacy.introduction': '序章',
  'privacy.introductionexpedia': `ワシントン州法人である Expedia, Inc.、およびその子会社および関連会社 (「当社」、「当社」、「当社」、および「Expedia」) は、お客様のプライバシーの権利を尊重し、お客様のプライバシーを真剣に受け止めています。 Expedia は、お客様から提供された個人情報を保護および保護するための適切な措置を講じることをお約束します。このプライバシー ポリシーでは、当社のウェブサイト、アプリ、オンライン予約 API (つまり、当社のパートナーが使用するオンライン予約ツール) を含む当社のオンライン サービス (「オンライン サービス」) を介して、お客様の個人情報を収集、使用、および共有する方法について説明します。その他の方法 (まとめて「サービス」)。当社のオンライン サービスの一部がお客様を第三者のオンライン サービスに接続する場合、それらのサービスはこのプライバシー ポリシーの下では動作しません。他のオンライン エリアに掲載されているプラ​​イバシー ポリシーを確認して、個人情報の収集、使用、開示の手順を理解してください。`,
  //<!------ key things --------!>
  'privacy.keythings':
    ' 当社がお客様の情報をどのように使用するかについて知っておくべき重要事項',
  'privacy.useinformation':
    '• 旅行の予約を完了する目的で、お客様の情報 (およびお客様と一緒に旅行する方の情報) を使用する場合があります。',
  'privacy.sharingbookinginformation':
    '• これには、お客様の予約を履行するために、お客様の予約情報を他の当事者と共有することが含まれます。',
  'privacy.engagethirdparty':
    '• 当社は、当社に代わってサービスまたは機能を提供する他のサードパーティ ベンダーと契約する場合もあります。',
  'privacy.receivemarketing':
    '• マーケティング情報を受け取ることを選択した場合、当社のロイヤルティ プログラムを含め、お客様が関心を持つ可能性のある特別オファーについてお知らせします。いつでもオプトアウトできます',
  'privacy.cancontactus':
    '• このプライバシー ポリシーの下部にある [お問い合わせ] セクション内の連絡先情報を使用して、情報の更新またはアクセスについて連絡することができます。',
  'privacy.useinformationpurposes':
    '• 当社は、以下を含むがこれらに限定されない目的で、Cookie などの情報を使用する場合があります。オンライン サービスでのエクスペリエンスの向上。サービス全般の改善。より関連性の高い広告やオファーを表示するため。',
  'privacy.feedbackprovide':
    '• ときどき、通常は当社とのやり取りの後、お客様や他の人により良いサービスを提供するために、フィードバックをお願いする場合があります。',
  'privacy.outsideServices':
    '• 米国外で当社のサービスを使用している場合、お客様の情報は、当社のサーバーが配置され、中央データベースが運用されている米国に転送、保存、および処理される可能性があることに注意してください。お客様のプライバシーとセキュリティを保護するために適切な措置を講じていますのでご安心ください。',
  'privacy.anyquestions':
    '•  このプライバシーポリシーを完全に読んで、完全に情報を得ることをお勧めします。当社によるお客様の個人情報の使用についてご質問やご不明な点がございましたら、本ポリシーの下部にある「お問い合わせ」セクションに記載されている情報からご連絡ください。',
  //<!------ collect information --------!>
  'privacy.collectinformation': '当社が収集する個人情報とその理由',
  'privacy.followingcategories':
    '当社がお客様に関して収集する可能性のある個人情報は、大まかに次のカテゴリに分類されます。',
  'privacy.providedirectly': 'あなたが私たちに直接提供する情報',
  'privacy.askinformation':
    '個人情報の提供を直接お願いする場合があります。たとえば、次のような目的で、必要に応じて氏名、住所、電話番号、電子メール アドレス、生年月日などの連絡先の詳細を提供するようお願いする場合があります。',
  'privacy.askenablebooking': '- 旅行の予約を有効にする ;',
  'privacy.askregisteraccount': '- アカウントを作成または登録する ;',
  'privacy.askrequestdetails':
    '- 予約に関する詳細など、お客様が要求するサービスと情報を提供する ;',
  'privacy.askemergencynumber': '- あなたの緊急連絡先番号を持っている ;',
  'privacy.askupdateloyalty':
    '- フリークエント フライヤーまたはロイヤルティ プログラムの情報を更新する ;',
  'privacy.asksubscribemarketing':
    '- 当社のマーケティングコミュニケーションを購読する ;',
  'privacy.askenquiries': '- お問い合わせ ;',
  'privacy.needprovide':
    'また、支払いを行うには、請求情報 (クレジット カード番号、カード所有者名、有効期限など) を提供する必要があります。.', //<!------ collect information --------!>
  'privacy.requiredprovide':
    'また、調査やコンテストに参加する場合は、予約に関する他の旅行者に関する情報、マーケティングの好み、および追加情報を提供する必要がある場合があります。アカウントを作成する際に、ログイン名/メンバー ID とパスワードを提供します。.',
  'privacy.linkedpersonalinformation':
    'お客様の個人情報は、当社のオンライン サービスの適切な運用を可能にし、お客様の旅行検索を当社のオンライン サービスに保存し、お客様が当社のオンライン サービスをどのように使用したかに関する情報を収集するために、Cookie にリンクされる場合もあります。詳細については、以下の「Cookie および類似の追跡技術」セクションを参照してください。.',
  'privacy.ifyouemployee':
    'あなたが企業アカウントの従業員、ベンダー、または不動産所有者、不動産管理者、旅行代理店などの他の種類のビジネス パートナーである場合、収集されるその他の情報には、雇用主、従業員 ID 番号、またはその他の関連する詳細が含まれる場合があります。',
  'privacy.useforpurposes':
    'また、以下の「お客様の情報の使用方法」セクションに記載されている他の目的のために、お客様の個人情報を使用する場合があります。',
  'privacy.specialCategories': '個人情報の特別なカテゴリー',
  'privacy.certaintypes':
    '一部の政府発行の ID 番号、宗教、健康状態、性別など、特定の種類の個人情報は機密情報と見なされ、適用法の下で追加の保護が必要です。当社は、機密性の高い個人情報を収集する状況を制限するために適切な措置を講じます。この情報の例は次のとおりです。',
  'privacy.healthrelated':
    '- 適切な旅行宿泊施設、アクセシビリティ、または施設の要件を提供するために、健康関連の情報が必要になる場合があります。',
  'privacy.governmentissued':
    '- フライト、レンタカー、その他の旅行の予約には、パスポートや運転免許証番号などの政府発行の識別番号が必要になる場合があります。',
  'privacy.otherspecifyoption':
    '- オプションで指定できるその他の情報で、宗教、健康、または食事の必要性などのその他の情報などの情報を暗示または示唆する可能性があるもの',
  'privacy.voluntarilyTravel': '旅行同行者について自発的に提供される情報',
  'privacy.travelpreferences':
    'お客様が当社のオンライン サービスを通じて他の人の予約を行う場合、当社はその個人に関する個人情報と旅行の好みを要求します。個人情報と旅行の好みを当社に提供する前に、他の個人の同意を得る必要があります。同行者の情報は、お客様のアカウントからのみ表示および修正できます。旅行同行者が自分の情報を自分で修正または削除したい場合は、このポリシーの下部にある「お問い合わせ」セクションの情報で直接ご連絡ください。',
  'privacy.collectautomatically': '自動的に収集する情報',
  'privacy.collectcertainautomatically':
    'お客様が当社のオンライン サービスにアクセスすると、お客様のデバイスから特定の情報が自動的に収集される場合があります。欧州経済地域の国を含む一部の国では、この情報は適用されるデータ保護法の下で個人情報と見なされる場合があります。',
  'privacy.Specifically':
    '具体的には、当社が自動的に収集する情報には、IP アドレス、デバイスの種類、一意のデバイス識別番号、ブラウザーの種類 (ファイアフォックス、サファリ、または インターネットエクスプローラ など)、インターネット サービス プロバイダー ( ISP)、お使いのオペレーティング システムと通信事業者。 Web サイトのユーザーについては、参照元の ウェブ サイトまたは終了ページの詳細、および広範な地理的位置 (国または都市レベルの位置など) も収集される場合があります。',
  'privacy.collecttechnicalinformation':
    'また、アクセスされたページやクリックされたリンクなど、お客様のデバイスが当社のオンライン サービスとどのようにやり取りしたかなど、その他の技術情報も収集する場合があります。',
  'privacy.enablesbetterunderstand':
    'この情報を収集することで、オンライン サービスにアクセスする訪問者、訪問者がどこから来たのか、オンライン サービスのどのコンテンツに関心があるのか​​をよりよく理解することができます。当社はこの情報を内部分析目的で使用し、訪問者向けのオンライン サービスの品質と関連性を向上させます。たとえば、ユーザー エクスペリエンスをカスタマイズし、検索を調整し、興味のある広告を表示します。また、この自動情報を使用して、詐欺を防止および検出することもあります。',
  'privacy.usingcookiessimilar':
    'この情報の一部は、「クッキー および同様の追跡技術」という見出しの下でさらに説明されているように、クッキー および同様の追跡技術を使用して収集される場合があります。',
  'privacy.collectwhenuseApps': 'アプリの使用時に収集する情報',
  'privacy.usesmartapp':
    'スマートフォン アプリ、タブレット アプリ、または他のプラットフォーム用のアプリケーション (該当する場合は総称して「アプリ」または「アプリ」) のいずれかを使用する場合、以下のような情報も収集することがあります。',
  'privacy.functionalityofapp':
    '- アクセスして使用するアプリの機能に関する情報。これにより、お客様が関心を持っているアプリの領域を特定して、アプリを改良し、継続的に改善することができます。',
  'privacy.deviceuid':
    '- デバイスの一意のデバイス識別子 (「UID」)。各アプリは、デバイスの UID (デバイスに固有の一連の数字または文字) を当社に送信します。アプリを最初に開いたときにこれを使用して、それぞれの広告バナーやその他のマーケティング ツールのクリックによるダウンロード数を広告ネットワークに確認できるようにします。電子メール アドレスが提供されると、デバイス間でシームレスなエクスペリエンスを提供する目的で、これを現在の UID/クッキーID に関連付けます。',
  'privacy.currentlocation':
    '- 現在地に関する情報。アプリの現在地付近のホテルを検索する機能、または位置情報に基づいて関連するコンテンツを提案する類似の機能を使用する場合、または位置情報に基づくサービスを提供する場合、GPS または類似の技術を使用してデバイスから提供される現在位置に関する情報を使用します。関連するコンテンツやその他のローカライズされた情報を表示します。位置情報に基づく機能を明示的に使用しない限り、位置データは収集されません。また、電話の設定メニューからいつでも位置データの収集をオフにすることができます。',
  'privacy.errorreporting':
    '- エラー報告情報。これにより、エラーを調査し、将来のリリースのためにアプリの安定性を向上させることができます。これらのエラー レポートの一部として、アプリはモバイル デバイスの種類とバージョン、UID、エラーが発生した時刻、使用されていた機能、エラーが発生したときのアプリケーションの状態に関する情報を当社に送信します。この情報を使用して、エラーを調査して修正し、影響を受けた予約を完了するのを支援する場合があります',
  'privacy.abilitytocontrol':
    'アプリが当社に送信する情報を制御することができます。アプリの設定メニューでアプリの設定を変更するか、モバイル デバイスの設定を変更することで、この制御を行うことができます。または、デバイスからアプリを完全に削除し、当社の Web サイトから当社のサービスにアクセスすることもできます。',
  'privacy.obtainparty': '第三者の情報源から取得する情報',
  'privacy.lawfullyaffiliated':
    '当社は定期的に、関連会社、ビジネス パートナー、およびその他の独立した第三者の情報源からお客様に関する個人情報を合法的に取得し、それを当社のアカウント情報に追加します。当社が受け取る情報の例には、電子メール、購入履歴、人口統計情報などの最新の連絡先情報が含まれます。',
  'privacy.collectcommunicate':
    '以下の方法でお客様が当社と通信する際に当社が収集する情報',
  'privacy.socialmedia':
    'ソーシャル メディア: お客様が当社のオンライン サービスで、またはソーシャル メディア プロバイダーを通じて当社のソーシャル メディア機能を利用する場合、当社は、プライバシー ポリシーに従って、そのソーシャル メディア プロバイダーを介してお客様に関する情報にアクセスする場合があります。たとえば、「フェイスブック 接続」機能を介して当社のウェブサイトに登録するオプションを提供しています。これにより、当社のウェブページで必要なデータを手動で入力することなく、フェイスブック アカウントのデータを使用して当社のウェブサイトに登録することができます。',
  'privacy.socialmediafeature':
    'ソーシャル メディア機能を使用する際、ソーシャル メディア アカウントに個人情報を含めることを選択した場合、名前、プロフィール写真、性別、誕生日、メール アドレス、町または地区、および選択したその他の情報にアクセスすることがあります。利用できるようにします。お客様のプライバシー設定に従い、関連するコンテンツを提供するために、お客様がソーシャル メディア プロバイダーに提供したそれぞれの場所に関する情報 (「場所データ」) にアクセスします。ソーシャル メディア サイトでつながっている友人に関連するデータを保存または使用することはありません。',
  'privacy.accesssocialmediaproviders':
    'また、ソーシャル メディア プロバイダーの Web サイトで実行するアプリの使用に関する情報にアクセスする場合もあります。したがって、使用するソーシャル メディア プロバイダーのプライバシー ポリシーを確認することをお勧めします。',
  'privacy.callmonitoring':
    '通話の監視と録音: 当社のカスタマー サービス チームとの通話は、品質管理、分析、法的紛争の際の当社の保護、およびスタッフのトレーニングのために、録音または監視される場合があります。通話録音は、このプライバシー ポリシーに従って維持されます。通話中に取得した個人情報は、本プライバシー ポリシーの規定に従って取り扱われます。',
  'privacy.onlinecommunications':
    'その他のオンライン コミュニケーション: チャットなど、オンライン サービスを介したお客様と当社とのやり取りは、品質管理の目的で記録および監視され、法的紛争が発生した場合に当社を保護し、スタッフのトレーニングを行います。この情報は、このプライバシー ポリシーに従って処理および維持されます。',
  'privacy.cookiessimilartracking': 'クッキーおよび類似の追跡技術',
  'privacy.cookiessmalldata':
    'クッキー は小さなデータ テキスト ファイルであり、コンピューターのハード ドライブに保存できます (ウェブ ブラウザーが許可している場合)。この ウェブ サイトでは、以下を含むがこれらに限定されない一般的な目的で Cookie を使用する場合があります。',
  'privacy.helprecognize':
    '- お客様が以前の訪問者であることを認識し、ブラウザが当社のサイトにアクセスしている間に設定された設定を保存および記憶できるようにするため',
  'privacy.helpcustomize':
    '- コンテンツのカスタマイズを支援するため。オンライン広告の慣行とお客様の選択に関する詳細については、以下の「カスタマイズされた広告の表示」セクションを参照してください。',
  'privacy.helpofferings':
    '- 提供物、広告、および電子メール通信を支援するため (どの電子メールを開いて行動するかを決定することにより)',
  'privacy.helpportion':
    '- ほとんどのブラウザーのツールバーのヘルプ部分には、ブラウザーが新しい クッキー を受け入れないようにする方法、新しい クッキー を受信したときにブラウザーに通知させる方法、または クッキー を無効にするように要求する方法が説明されています。クッキーの受け入れを拒否すると、当社のサイトで提供されている多くの旅行ツールにアクセスできなくなる可能性があることに注意してください。',
  'privacy.additionabovecookies': `上記の クッキー に加えて、Web サイトでは「フラッシュ クッキー」とも呼ばれるローカル共有オブジェクトを使用する場合があります。これらは、たとえば、ボリューム/ミュート設定などのユーザー設定と設定を保存することにより、また当社の ウェブ サイトのアニメーション コンテンツに関連して、ユーザー エクスペリエンスを向上させるために使用されます。ローカル共有オブジェクトはブラウザの Cookie に似ていますが、単純なテキストよりも複雑なデータを保存できます。フラッシュ クッキー の詳細や無効にする方法については、次のサイトをご覧ください。`,
  'privacy.flashplayerhelp': 'フラッシュプレーヤー ヘルプ サイト',
  'privacy.webbeacons':
    'このサイトでは、ウェブ ビーコン (クリア gif、ピクセル タグ、または Web バグとも呼ばれます) ウェブ ページのコードに配置される、クッキー と同様の機能を持つ一意の識別子を持つ小さなグラフィックです。 ウェブ ビーコンを使用して、サイト内のあるページから別のページへのユーザーのトラフィック パターンを監視し、クッキー を配信または読み取り、第三者の Web サイトに表示されたオンライン広告から当社のサイトにアクセスしたかどうかを理解し、改善します。サイトのパフォーマンス。また、サービス プロバイダーが Web ビーコンを使用して、たとえば、受信者が開封した電子メールを理解したり、サイトでの訪問者のトラフィックやアクションを追跡したりすることを許可する場合があります。これは、コンテンツやその他の提供物の有効性を測定するのに役立ちます。',
  'privacy.combineinformation':
    '当社は、お客様から提供された情報を、お客様の取引に関連する情報、および当社に代わってサービスを実行する第三者から受け取ったお客様に関する情報と組み合わせる場合があります。 Cookie および同様の技術を介して受け取った情報により、デバイス全体でのユーザーのアクティビティと、クッキー に関連付けられたユーザーのクリックストリーム データを追跡できる場合があります。',
  'privacy.ingeneral':
    '一般に、当社は、お客様から収集した個人情報を、このプライバシー ポリシーに記載されている目的、またはお客様の個人情報を収集する際に説明する目的にのみ使用します。',
  'privacy.whosharewith': '個人情報の共有先',
  //<!-------- share information ----------!>
  'privacy.shareinfopart1':
    '当社のグループ会社 お客様の個人情報は、expediagroup.com Web サイトに掲載されている Expedia Group ファミリーの関連会社と共有される場合があります。',
  'privacy.shareinfopart2':
    'この共有により、たとえば、当社が提供する製品やサービスを強化したり、旅行関連やその他の製品やサービスに関する情報を提供したりすることができます。 また、HomeAway などの別の Expedia Group ブランドを通じてバケーション レンタルの予約について問い合わせた場合、たとえば、以前の旅行回数や、Expedia Group ブランドでのステータス レベルなどを休暇と共有することがあります。 レンタル所有者は、あなたの滞在を承認する際に追加の安心感を与えることができます. 当社の親会社および関連会社がお客様の情報にアクセスできる範囲で、このプライバシー ポリシーに記載されている慣行と少なくとも同じくらい制限的な慣行に従います。 また、プロモーション通信の送信を管理する適用法を遵守するための適切な措置を講じ、少なくとも、今後そのようなメール メッセージを受信しないことを選択する機会を送信するプロモーション メールで提供します。',
  'privacy.shareinfopart3': `当社にデータ処理サービスを提供するサード パーティ サービス プロバイダー (たとえば、オンライン サービスの配信のサポート、機能の提供、またはオンライン サービスのセキュリティ強化の支援)、またはクレジット カード処理などの目的で個人情報を処理するサード パーティ サービス プロバイダー 、ビジネス分析、顧客サービス、マーケティング、調査または懸賞プログラムの配布、詐欺防止。 サードパーティのサービス プロバイダーがデータにアクセスできる場合、その機能を実行するために必要な情報のみを収集します。 他の目的で情報を共有または使用することは許可されていません。`,
  'privacy.shareinfopart4': `製品またはサービスを共同で提供するビジネス パートナー、または製品またはサービスをオンライン サービスで提供するビジネス パートナー。 サードパーティのビジネス パートナーが、お客様が要求した製品またはサービスに関与している場合は、その名前が単独で、または当社の名前とともに表示されるため、それを知ることができます。 これらのオプション サービスへのアクセスを選択した場合、当社は、お客様の個人情報を含むお客様に関する情報をこれらのパートナーと共有することがあります。 ビジネス パートナーの例としては、予約を通じてポイントを獲得できるサードパーティのロイヤルティ プログラムがあります。`,
  'privacy.shareinfopart5':
    'お客様の旅行予約を履行する、ホテル、航空会社、レンタカー、保険、不動産所有者、および利用可能な場合はアクティビティ プロバイダー、鉄道およびクルーズ会社などの旅行業者。 サードパーティのサプライヤによって提供されるサービスは、一般的にそのように説明されています。 これらのサプライヤーは、独自の独立したプライバシー ポリシーに従って、お客様に関する追加情報の取得、旅行予約の円滑化、またはお客様が送信したレビューへの返信を行うために、必要に応じてお客様に連絡する場合があることにご注意ください。 時折、匿名のレビューをホテルのサプライヤーと共有することがあります。 このような場合、明示的に許可しない限り、レビュアーの名前や連絡先情報を共有することはありません。 ホテルがレビューの内容からお客様の身元を推測し、お客様に直接連絡することについて、当社は責任を負いません。',
  'privacy.shareinfopart6':
    'ソーシャル メディア プロバイダー オンライン サービスを通じて特定のソーシャル メディア機能にアクセスすると、ソーシャル メディア プロバイダー (Facebook など) と情報を共有することになります。 お客様が共有する情報は、ソーシャル メディア プロバイダーのプライバシー ポリシー (ソーシャル メディア プロバイダーを介してアクセスする可能性のあるデータを含む) によって管理されます。 ソーシャル メディア プロバイダーは、サイトでプライバシー設定を変更する方法について通知する必要があります。',
  'privacy.shareinfopart7':
    'お客様が「Facebook Connect」などを通じて Expedia.com アカウントをソーシャル メディア プロバイダーに接続する場合、当社はそのソーシャル メディア プロバイダーに、当社の特典やロイヤルティ プログラムなど、お客様による当社のサービスの使用に関連する情報を提供する場合があります。 お客様が当社のオンライン サービスに投稿したレビュー。',
  'privacy.shareinfopart8':
    'ソーシャル メディア プロバイダーは、ソーシャル メディア プロバイダーがそのような情報の共有やその他のプライバシーの選択を無効にするように要求できるようにする設定を提供する場合があります。',
  'privacy.shareinfopart9':
    '• (i) 適用される法律または規制の問題として、(ii) 当社の法的権利を行使、確立、または防御するために、または ( iii) お客様または他の人の利益を保護するため。',
  'privacy.shareinfopart10':
    '違法行為または違法行為の疑いに関する調査、防止、または措置をとることが適切であると当社が判断した場合。 当社またはこの Web サイト、お客様、またはその他の権利、財産、または安全を保護および防御するため。 当社の利用規約およびその他の契約に関連して。',
  'privacy.shareinfopart11':
    '売却、合併、統合、資産売却などの企業取引に関連する場合、または万一倒産した場合。 買収の場合、当社は購入者に、お客様の個人情報をこのプライバシー ポリシーで開示されている目的にのみ使用する必要があることを通知します。 また',
  'privacy.shareinfopart12': '開示に同意したその他の者。',
  'privacy.shareinfopart13':
    '場合によっては、集計情報または匿名情報を広告主や投資家を含む第三者と共有することがあります。 たとえば、当社のウェブサイトの訪問者数や、最も人気のあるホテルや休暇の目的地を広告主に伝える場合があります。',
  //<!-------- use information ----------!>
  'privacy.useinfopart1':
    '当社は、収集した情報を、お客様および当社のビジネス用途をサポートするためのさまざまな目的で使用します。s',
  'privacy.useinfopart2': 'ホテルの予約など、お客様が行う取引の履行。',
  'privacy.useinfopart3':
    '旅行の確認と今後の旅行に関する重要な旅行の最新情報を (電子メール、SMS、および/またはプッシュ メッセージなどのチャネルを介して) 提供します。s',
  'privacy.useinfopart4': '詐欺防止目的で身元を確認します。',
  'privacy.useinfopart5': '支払いの処理を含むアカウントの管理。',
  'privacy.useinfopart6':
    '特に予約に変更があった場合に、一般的にお客様と連絡をとる。',
  'privacy.useinfopart7':
    'お客様の予約に関連するカスタマー サービスを提供するため、またはお客様からのお問い合わせに対応するため。',
  'privacy.useinfopart8':
    '当社の製品、サービス、およびウェブサイトの機能への関心を測定し、改善します。',
  'privacy.useinfopart9':
    '特別オファー、クーポン、懸賞、旅行関連の商品やサービスについてお知らせします。 これらは、電子メール、SMS、プッシュ メッセージ、郵便、電話などのさまざまなチャネルを通じて、またはソーシャル メディアを含むサードパーティ サイトの広告を通じて受け取ることができます。',
  'privacy.useinfopart10':
    'それ以外の場合は、この Web サイトまたはアプリでのエクスペリエンスをカスタマイズします。',
  'privacy.useinfopart11':
    'あなたが参加することを選択した報酬および表彰プログラムの一部としてあなたに報酬を与える（これが私たちのプログラムであるか第三者のプログラムであるかにかかわらず）;',
  'privacy.useinfopart12':
    'お客様が提供するフィードバックやアンケートなどを通じて、お客様から情報を取得する。',
  'privacy.useinfopart13':
    '当社のウェブサイトとアプリ、および当社が提供するサービスの使用に関する統計分析を実行して、当社の業務の各側面を改善します。',
  'privacy.useinfopart14':
    'たとえば、知的財産など、会社としての権利を保護します。',
  'privacy.useinfopart15':
    '紛争の解決、手数料の徴収、または問題のトラブルシューティング。',
  'privacy.useinfopart16':
    '潜在的に禁止されている、または違法な活動を防止する。',
  'privacy.useinfopart17': '当社の利用規約およびその他の契約を執行する。 と',
  'privacy.useinfopart18': '収集の時点でお客様に別段の説明がある場合。',
  'privacy.useinfopart19':
    '当社がお客様の個人情報を収集および使用する法的根拠についてご質問がある場合、または詳細情報が必要な場合は、このプライバシー ポリシーの下部に記載されている情報までお問い合わせください。',
  //<!------- international data transfer --------!>
  'privacy.transferdatatitle': '国際データ転送',
  'privacy.transferdatahere': 'ここ',
  'privacy.transferdatapart1':
    '当社が収集する、または当社に代わって収集する個人情報は、お客様が居住する国以外の国に転送され、処理される場合があります。 これらの国には、お客様の国の法律とは異なるデータ保護法が適用されている場合があります (場合によっては、保護が不十分な場合もあります)。 そのような情報は、お客様の居住国以外にある場合、そのような他の国の法律の対象となり、その国の法律に従って、そのような他の国の政府、裁判所、法執行機関、または規制機関に開示される可能性があります。',
  'privacy.transferdatapart2':
    '具体的には、当社のオンライン サービスのサーバーは米国にあり、当社のグループ会社とサード パーティのサービス プロバイダーは世界中で運営されています。 これは、当社がお客様の個人情報を収集する場合、これらの国で処理する場合があることを意味します。',
  'privacy.transferdatapart3': 'EU-US およびスイス-US プライバシー シールド',
  'privacy.transferdatapart4':
    '当社は、欧州連合およびスイスからの個人情報の収集、使用、および保持に関して米国商務省が定めた EU-米国間およびスイス-米国間のプライバシー シールド フレームワークに準拠していることを自己認証しています。 当社は、プライバシー シールドの通知、選択、転送の説明責任、セキュリティ、データの完全性と目的の制限、アクセス、および償還、執行、責任の原則を順守していることを証明しています。 プライバシー シールドの原則の詳細と当社の認定を確認するには、次の ウェブ サイトにアクセスしてください。',
  'privacy.transferdatapart5':
    '当社は、本プライバシー ポリシーで前述した目的 (またはお客様が後で承認したもの) に適合する方法でのみ、個人情報を処理します。 実質的に異なる目的で個人情報を使用したり、独立した第三者に開示したりする前に、オプトアウトする機会を提供します。 個人情報の使用と開示を制限するためのその他の選択肢と手段については、以下の「情報の選択肢」セクションに記載されています。',
  'privacy.transferdatapart6':
    'このプライバシー ポリシーで説明されているように、当社は、当社に代わってサービスを提供する第三者にお客様の個人情報を提供する場合があります。 プライバシー シールドの下で受け取った個人情報を第三者のエージェントまたはサービス プロバイダーに転送し、それらがプライバシー シールドの原則と矛盾する方法でお客様の個人情報を処理した場合、責任を負わないことを証明できない限り、プライバシー シールドの下で責任を負います。 損害の原因となった事象について。',
  'privacy.transferdatapart7':
    '特定の状況下では、国家安全保障または法執行機関の要件を満たすことを含め、公的機関からの有効な要求に応じて、お客様の個人情報を開示する必要がある場合があります。',
  'privacy.transferdatapart8':
    'お客様は、当社が保有するお客様の個人情報にアクセスし、それが不正確であるか、プライバシー シールドに違反して処理されている場合、当社がその情報を修正、修正、または削除するよう要求する権利を有する場合があります。',
  'privacy.transferdatapart9':
    'プライバシー シールドに基づくお客様の個人情報の取り扱いについてお問い合わせまたは苦情がある場合は、まずprivacy@expedia.comまでご連絡ください。お問い合わせには迅速に対応いたします。 お客様の苦情を十分に解決できない場合、またはお客様の苦情をタイムリーに確認できなかった場合、当社は欧州データ保護機関 (DPA) のパネルおよびスイス連邦データ保護および情報コミッショナーに協力し、遵守することを約束します。 プライバシー シールドに関する苦情の解決において。 個人は、上記のメカニズムによって解決されないプライバシー シールドに関する苦情について、特定の条件下で拘束力のある仲裁を求める機会を持つこともできます。 見る',
  'privacy.transferdatapart10': '拘束力のある仲裁に関する追加情報については、.',
  'privacy.transferdatapart11':
    'プライバシー シールド フレームワークへの準拠を強制する目的で、当社は米国連邦取引委員会の調査および執行権限の対象となります。',
  //<!------ protect info --------!>
  'privacy.protectoinfopart1':
    'オンライン サービスを使用して旅行を手配することに自信を持っていただきたいと考えており、収集した情報を保護するために設計された適切な措置を講じることをお約束します。 絶対的なセキュリティを保証できるオンライン サービスはありませんが、当社は、お客様に関して収集および処理する個人情報を保護するために、適切な技術的および組織的対策を実施しています。',
  //<!------ choice info ---------!>
  'privacy.choiceinfotitle': 'あなたの情報の選択',
  'privacy.choiceinfohere': 'ここ',
  'privacy.choiceinfoand': 'と',
  'privacy.choiceinfoor': 'また',
  'privacy.choiceinfopart1':
    'オンライン サービスの [アカウント] セクションで、特定の連絡先情報にアクセスしたり、更新したりできます。 このポリシーの下部に記載されている連絡先情報を通じて当社に連絡することにより、いつでもアカウントの無効化を要求できます。 アカウントを無効にすると、サインインしたり、個人情報にアクセスしたりできなくなります。 ただし、いつでも新しいアカウントを開くことができます。',
  'privacy.choiceinfopart2':
    'お客様の情報について他にご質問がある場合は、このプライバシー ポリシーの下部に記載されている情報までお問い合わせください。',
  'privacy.choiceinfopart3': 'オーダーメイド広告の表示',
  'privacy.choiceinfopart4':
    '関連する広告を提供するために、このウェブサイトで当社が収集したデータ',
  'privacy.choiceinfopart5':
    '. 私たちはあなたに関連するコンテンツと情報を提供することをお約束します。 これを行うために、この ウェブ サイトで使用されている Cookie やその他の技術を通じて、旅行関連の検索や、フライトまたはホテルを探しているかどうかなど、お客様に関する情報を収集する場合があります。 この情報は、他の情報源から収集した他の情報とともに使用して、当社の ウェブ サイト、インターネット、およびユーザーが使用する他のデバイスでより関連性の高い広告を表示する場合があります。 したがって、たとえば、このサイトでロンドンの物件を検索すると、このサイトまたはアクセスした別の ウェブ サイトでロンドン旅行パッケージの広告が表示される場合があります。',
  'privacy.choiceinfopart6':
    'このウェブサイトでの活動に基づいて、他のウェブサイトでカスタマイズされたオンライン広告を受信しないことを選択できます。また、次のリソースのいずれかにアクセスして、カスタマイズされた広告目的での情報の使用をオプトアウトする方法の多くをご覧ください。 :',
  'privacy.choiceinfopart7':
    'カスタマイズされた広告を受信しないことを選択した場合でも、オンライン広告は表示されますが、より一般的で関連性が低くなります。',
  'privacy.choiceinfopart8':
    '関連する広告を提供するためにビジネス パートナーや広告ネットワークによって収集されたデータ',
  'privacy.choiceinfopart9':
    '. 当社は、クッキー やその他の技術を通じて、第三者がお客様のオンライン活動に関する情報を収集することを許可する場合があります。 これらの第三者には次のものが含まれます。 (2) 広告ネットワーク。インターネット上のさまざまな ウェブ サイトに掲載されている広告または追跡メカニズムの 1 つを閲覧または操作する際に、お客様の関心に関する情報を収集します。 これらの第三者によって収集された情報は、たとえば、お客様の特徴、興味、または好みに関する予測を行うため、およびお客様の明らかな興味に合わせて当社のサイトおよびインターネット上に広告を表示するために使用されます。',
  'privacy.choiceinfopart10':
    'これらの第三者がお客様の関心に関する情報を収集するために使用する可能性のある クッキー またはその他の技術にアクセスしたり制御したりすることはできず、これらの第三者の情報慣行はこのプライバシー ポリシーの対象外であることに注意してください。 これらの企業の一部は、ネットワーク広告イニシアチブのメンバーであり、メンバー企業からの広告ターゲティングをオプトアウトする単一の場所を提供しています. 詳細については、クリックしてください',
  'privacy.choiceinfopart11': '追跡しません 信号と同様のメカニズム',
  'privacy.choiceinfopart12': `. 一部の ウェブ ブラウザーは、ブラウザーが通信する ウェブ サイトに「トラッキング拒否」信号を送信する場合があります。 ウェブ ブラウザーがこの機能を組み込み、アクティブ化する方法が異なるため、ユーザーがこれらの信号を送信することを意図しているかどうか、またはユーザーがそれらを認識しているかどうかさえ、必ずしも明確ではありません。 この問題に取り組んでいる主要なインターネット標準設定組織の参加者は、そのような信号を受信したときに ウェブ サイトが何をすべきかを決定する過程にあります。 現在、これらのシグナルに対応する措置は講じていません。 最終的な基準が確立され、承認された場合、これらのシグナルへの対応方法を再評価します。`,
  //<!------ change notice -------!>
  'privacy.changenoticetitle': 'この通知の変更と当社への連絡方法',
  'privacy.changenoticepart1': 'このプライバシー ポリシーの更新',
  'privacy.changenoticepart2':
    'このプライバシー ポリシーは、法律、技術、またはビジネスの発展の変化に応じて、必要に応じて変更されます。 当社がプライバシーポリシーを更新する際には、当社が行う変更の重要性と一致し、適用法に従って、適切な措置を講じてお客様に通知します。 このプライバシー ポリシーの上部に表示されている「最終更新日」をチェックすることで、このプライバシー ポリシーが最後に更新された日付を確認できます。」',
  'privacy.changenoticepart3':
    'このプライバシーポリシーの変更についてご不明な点がございましたら、下記までお問い合わせください。',
  //<!------ contact us ------!>
  'privacy.contactuspart1':
    'このポリシー内の個人情報および情報の使用について質問または懸念がある場合は、カスタマー サービス ポータルのプライバシー セクションからご連絡ください。',
  'privacy.contactuspart2': 'ここ',
};
